import './App.css';
import Nav from "./nav/Nav.ts";
import { Content } from "./content/Content";

function App() {
  return (
    <>
      <Nav></Nav>
      <Content></Content>
    </>
  );
}

export default App;
